import { useState, useEffect } from 'react';

import AgentInspectionService from "../services/AgentInspectionService";
import LogUtils from "../utils/LogUtils";

const TAG = "useAgentInspectionService";
const logUtils = new LogUtils();

export function useGetAgentInspection({denounceId}) {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(null);
  const [agentInspections, setAgentInspections] = useState(null);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
      setAgentInspections(null);
    };
  }, []);

  useEffect(() => {
    async function getAgentInspection() {
      try {
        if (!isMounted) return false;

        setIsLoading(true);
        const agentInspectionService = new AgentInspectionService();
        const response = await agentInspectionService.getAgentInspectionByDenounceId(denounceId);
        setIsLoading(false);

        if (!isMounted || !response?.data?.[0]) return false;

        setAgentInspections(response?.data?.[0]);

      } catch (err) {
        logUtils.logErrorMsg(TAG, "Failed to getAgentInspection", err);
        setIsLoading(false);
      }
    }

    getAgentInspection();

    return () => {
      setAgentInspections(null);
    };
  }, [isMounted, denounceId]);

  return [isLoading, agentInspections];
}
